import { Box, styled, TableCell, tableCellClasses, TableRow, Typography } from '@mui/material';

import type { ExtendedSeriesOptionsType } from '@/components/Chart/types/highcharts';
import FactsheetDialogButton from '@/features/Factsheet/components/FactsheetDialogButton';

import LegendCheckBox from './LegendCheckBox';
import VisibilityToggleButton from './VisibilityToggleButton';

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14
  }
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  height: '22px',
  paddingBottom: 8,
  verticalAlign: 'center',
  borderBottom: `0.5px solid ${theme.palette.info.light}`,
  '&:last-child tr': { border: 0, borderBottom: 0 }
}));

const LegendItem = ({ series }: { series: ExtendedSeriesOptionsType }) => {
  const context = series?.custom;
  if (context) {
    return (
      <StyledTableRow
        key={series.name + context.field}
        sx={{ '&:last-child': { borderBottom: 0 } }}
      >
        <StyledTableCell
          scope='row'
          sx={{ pr: 1 }}
          width={70}
        >
          <Box
            alignItems='center'
            display='flex'
            gap={1}
          >
            <LegendCheckBox series={series} />
            <VisibilityToggleButton series={series} />
            <div
              style={{
                width: 16,
                height: 2,
                flexShrink: 0,
                backgroundColor: series.color as string
              }}
            />
          </Box>
        </StyledTableCell>
        <TableCell
          sx={{ pr: 5 }}
          width={50}
        >
          <Typography variant='body2'>{context.Code}</Typography>
        </TableCell>
        <TableCell
          align='right'
          sx={{ pr: 5 }}
          width={100}
        >
          <Typography variant='body2'>{context.TimeRef}</Typography>
        </TableCell>
        <TableCell
          align='right'
          sx={{ pr: 5 }}
          width={120}
        >
          <Typography variant='body2'>{context.PeriodType}</Typography>
        </TableCell>
        <TableCell
          align='right'
          sx={{ pr: 5 }}
          width={80}
        >
          <Typography variant='body2'>{context.Period}</Typography>
        </TableCell>

        <TableCell
          align='left'
          sx={{ pr: 5 }}
          width={110}
        >
          <Typography variant='body2'>{context.Alias}</Typography>
        </TableCell>

        <TableCell sx={{ pr: 5 }}>
          <Typography variant='body2'>{context.Title}</Typography>
        </TableCell>

        <TableCell
          align='right'
          sx={{ pr: 5 }}
          width={80}
        >
          <Typography variant='body2'>{context.Currency}</Typography>
        </TableCell>
        <TableCell
          align='right'
          sx={{ pr: 5 }}
          width={80}
        >
          <Typography variant='body2'>{context.Units}</Typography>
        </TableCell>
        <TableCell
          align='right'
          width={60}
        >
          <FactsheetDialogButton code={context.Code} />
        </TableCell>
      </StyledTableRow>
    );
  }
};
export default LegendItem;
